import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { isLogin } from '../../utils';

import Header from '../layouts/Header';
import Footer from '../layouts/Footer';

const PublicRoute = ({component: Component, restricted, ...rest}) => {
    return (
        <Route {...rest} render={props => (
            isLogin()==false && restricted ?
                <Redirect to="/" />
            : <><Header {...props}/><Component {...props} /><Footer {...props}/></>
        )} />
    );
};

export default PublicRoute;